import * as ActionTypes from './constants';

export const defaultState = () => ({
  leads: [],
  leadsCount: 0,
  pending: false,
  withFinancing: false,
  updatePending: false,
  leadIdBeingUpdated: null,
  error: null,
});

export function openLeads(state = defaultState(), action) {
  const { error, payload, type } = action;

  if (type === ActionTypes.GET_OPEN_LEADS_REQUEST) {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }

  if (type === ActionTypes.GET_OPEN_LEADS_SUCCESS) {
    const { sales, salesCount } = payload;

    return {
      ...state,
      leads: sales,
      leadsCount: salesCount,
      pending: false,
      error: null,
    };
  }

  if (type === ActionTypes.GET_OPEN_LEADS_ERROR) {
    return {
      ...state,
      error,
      leads: [],
      leadsCount: 0,
      pending: false,
    };
  }

  // open lead (v2)
  if (type === ActionTypes.UPDATE_OPEN_LEAD_REQUEST) {
    return {
      ...state,
      error: null,
      updatePending: true,
      leadIdBeingUpdated: action.id,
    };
  }

  if (type === ActionTypes.UPDATE_OPEN_LEAD_SUCCESS) {
    const _leads = [...state.leads];
    const lead = payload;
    const foundIndex = _leads.findIndex(item => item.id === lead.id);

    if (foundIndex !== -1) {
      _leads[foundIndex] = lead;

      return {
        ...state,
        leads: _leads,
        error: null,
        updatePending: false,
        leadIdBeingUpdated: null,
      };
    }
  }

  if (type === ActionTypes.UPDATE_OPEN_LEAD_ERROR) {
    return {
      ...state,
      error,
      updatePending: false,
      leadIdBeingUpdated: null,
    };
  }

  if (type === ActionTypes.UPDATE_LEAD_FINANCING_REQUEST) {
    return {
      ...state,
      error: null,
      updatePending: true,
    };
  }

  if (type === ActionTypes.UPDATE_LEAD_FINANCING_SUCCESS) {
    const _leads = [...state.leads];
    const lead = payload;
    const foundIndex = _leads.findIndex(item => item.id === lead.id);

    if (foundIndex !== -1) {
      _leads[foundIndex] = lead;

      return {
        ...state,
        leads: _leads,
        error: null,
        updatePending: false,
      };
    }
  }

  if (type === ActionTypes.UPDATE_LEAD_FINANCING_ERROR) {
    return {
      ...state,
      error,
      updatePending: false,
    };
  }

  if (type === ActionTypes.SUBMIT_LEAD_SALE_STATES_REQUEST) {
    return {
      ...state,
      error: null,
      updatePending: true,
    };
  }

  if (type === ActionTypes.SUBMIT_LEAD_SALE_STATES_SUCCESS) {
    return {
      ...state,
      error: null,
      updatePending: false,
    };
  }

  if (type === ActionTypes.SUBMIT_LEAD_SALE_STATES_ERROR) {
    return {
      ...state,
      error,
      updatePending: false,
    };
  }

  return state;
}
